function joinClassNames(...names) {
  return names.filter(Boolean).join(" ");
}

export function InlineAlert({
  tone = "danger",
  title,
  action,
  className = "",
  children,
}) {
  const isUrgent = tone === "danger";

  return (
    <div
      className={joinClassNames("ds-inline-alert", `ds-inline-alert--${tone}`, className)}
      role={isUrgent ? "alert" : "status"}
    >
      <div className="ds-inline-alert__content">
        {title ? <strong>{title}</strong> : null}
        {children ? <div className="ds-inline-alert__message">{children}</div> : null}
      </div>
      {action ? <div className="ds-inline-alert__action">{action}</div> : null}
    </div>
  );
}

export function EmptyState({ title, description, action, className = "" }) {
  return (
    <div className={joinClassNames("ds-empty-state", className)}>
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
      {action ? <div className="ds-empty-state__action">{action}</div> : null}
    </div>
  );
}
